var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.139,
    height: 223.534,
    viewBox: "0 0 170.139 223.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lock",
    transform: "translate(-10454.647 -187.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M10491.19,274.15V243.107a48.169,48.169,0,0,1,48.17-48.169h0a48.169,48.169,0,0,1,48.168,48.169V274.15",
    fill: "none",
    stroke: "#f37521",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    d: "M10500.346,263.412h78.741a45.619,45.619,0,0,1,45.619,45.619v56.244a45.62,45.62,0,0,1-45.619,45.62h-78.741a45.62,45.62,0,0,1-45.619-45.62V309.031a45.619,45.619,0,0,1,45.619-45.619Z",
    fill: "#f37521",
    stroke: "#f37521",
    strokeWidth: 0.154
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    d: "M10503.471,263.412h67.493a48.743,48.743,0,0,1,48.743,48.744h0V362.15a48.743,48.743,0,0,1-48.742,48.745h-67.494a48.744,48.744,0,0,1-48.744-48.744h0V312.156a48.744,48.744,0,0,1,48.744-48.744Z",
    fill: "#f37521",
    stroke: "#f37521",
    strokeWidth: 0.154
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M10563.98,327.673a24.264,24.264,0,1,0-32.765,22.73l-.777,16.991a3.645,3.645,0,0,0,3.476,3.808c.03,0,.061,0,.092,0h12.845a3.646,3.646,0,0,0,3.637-3.655c0-.052,0-.1,0-.156l-.875-17.6a24.263,24.263,0,0,0,14.365-22.123Z",
    fill: "#f4f5f9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/Lock2.44c2b5870656801f524171433dd14142.svg";
export { ForwardRef as ReactComponent };